import { render } from "./UserUpdatePhoto.vue?vue&type=template&id=55016530&scoped=true"
import script from "./UserUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./UserUpdatePhoto.vue?vue&type=script&lang=js"

import "./UserUpdatePhoto.vue?vue&type=style&index=0&id=55016530&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55016530"]])

export default __exports__